/* 🤖 this file was generated by svg-to-ts */
export const matIconElectricBolt: {
  name: 'electric-bolt';
  data: string;
} = {
  name: 'electric-bolt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14.69 2.21 4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 0 0-1.08-.02z"/></svg>`
};
